export enum ServicesStatuses {
  ACTIVE = 'ACTIVE',
  NOTACTIVE = 'NOTACTIVE',
  ACTIVE_OPTION = 'ACTIVE_OPTION',
  PENDINGACTIVATION = 'PENDINGACTIVATION',
  PENDINGDEACTIVATION = 'PENDINGDEACTIVATION',
}

export enum ServicesStates {
  NOTACTIVE = 'notactive-service',
  ACTIVE = 'active-service',
  PENDING = 'pending-service',
  PENDINGACTIVATION = 'pending-activation',
  PENDINGDEACTIVATION = 'pending-deactivation'
}

export const serviceStatusStates = {
	[ServicesStatuses.NOTACTIVE]: ServicesStates.NOTACTIVE,
	[ServicesStatuses.ACTIVE]: ServicesStates.ACTIVE,
	[ServicesStatuses.ACTIVE_OPTION]: ServicesStates.NOTACTIVE,
	[ServicesStatuses.PENDINGACTIVATION]: ServicesStates.PENDING,
	[ServicesStatuses.PENDINGDEACTIVATION]: ServicesStates.PENDING,
};
